/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react/function-component-definition */
/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable import/no-extraneous-dependencies */
import ReactMarkdown, { Options as ReactMarkdownOptions } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { FC, memo } from 'react';
import { cn } from '../../_helpers/globalHelper';

// Define our custom components for react-markdown
const markdownComponents: ReactMarkdownOptions['components'] = {
  h1: ({ className, ...props }) => (
    <h1
      className={cn(
        'mt-2 scroll-m-20 text-xl font-bold tracking-tight', // was text-4xl lg:text-5xl
        className
      )}
      {...props}
    />
  ),
  h2: ({ className, ...props }) => (
    <h2
      className={cn(
        'mt-6 scroll-m-20 border-b pb-2 text-lg font-semibold tracking-tight first:mt-0', // was text-3xl
        className
      )}
      {...props}
    />
  ),
  h3: ({ className, ...props }) => (
    <h3
      className={cn(
        'mt-4 scroll-m-20 text-base font-semibold tracking-tight', // was text-2xl
        className
      )}
      {...props}
    />
  ),
  h4: ({ className, ...props }) => (
    <h4
      className={cn(
        'mt-4 scroll-m-20 text-sm font-semibold tracking-tight', // was text-xl
        className
      )}
      {...props}
    />
  ),
  p: ({ className, ...props }) => (
    <p className={cn('leading-7 [&:not(:first-child)]:mt-4', className)} {...props} />
  ),
  a: ({ className, ...props }) => (
    <a
      className={cn('font-medium text-primary underline underline-offset-4', className)}
      {...props}
    />
  ),
  ul: ({ className, ...props }) => (
    <ul className={cn('my-1 ml-6 list-disc [&>li]:mt-2', className)} {...props} />
  ),
  ol: ({ className, ...props }) => (
    <ol className={cn('my-1 ml-6 list-decimal [&>li]:mt-2', className)} {...props} />
  ),
  li: ({ className, ...props }) => <li className={cn('', className)} {...props} />,
  blockquote: ({ className, ...props }) => (
    <blockquote className={cn('mt-4 border-l-2 pl-4 italic', className)} {...props} />
  ),
  img: ({ className, alt, ...props }) => (
    <img className={cn('rounded-md border', className)} alt={alt} {...props} />
  ),
  hr: ({ ...props }) => <hr className="my-4 md:my-8" {...props} />,
  table: ({ className, ...props }) => (
    <div className="my-4 w-full overflow-y-auto">
      <table className={cn('w-full', className)} {...props} />
    </div>
  ),
  tr: ({ className, ...props }) => (
    <tr className={cn('m-0 border-t p-0 even:bg-muted', className)} {...props} />
  ),
  th: ({ className, ...props }) => (
    <th
      className={cn(
        'border px-4 py-2 text-left font-bold [&[align=center]]:text-center [&[align=right]]:text-right',
        className
      )}
      {...props}
    />
  ),
  td: ({ className, ...props }) => (
    <td
      className={cn(
        'border px-4 py-2 text-left [&[align=center]]:text-center [&[align=right]]:text-right',
        className
      )}
      {...props}
    />
  ),
  pre: ({ children }) => <>{children}</>,
  code: ({ children }) => <>{children}</>
};

interface MarkdownTextProps {
  children: string;
  className?: string;
}

const MarkdownTextImpl: FC<MarkdownTextProps> = ({ children, className }) => {
  return (
    <div className={cn('prose dark:prose-invert max-w-none', className)}>
      <ReactMarkdown components={markdownComponents} remarkPlugins={[remarkGfm]}>
        {children}
      </ReactMarkdown>
    </div>
  );
};

const MarkdownText = memo(MarkdownTextImpl);

export default MarkdownText;
